import { useState } from 'react'
import { ProductAvailableTimeSummary } from '../../../types/product';
import { IMAGE_BASE_URL } from '../../../utils/env';
import noImgCoffee from "../../../assets/images/noImg.jpg";
import { GridiconsAdd } from '../../../assets/icons/Icons';

interface AvailableProductItemProps {
    product: ProductAvailableTimeSummary;
    category: string;
    onClick: (product: ProductAvailableTimeSummary) => void;
}

export default function AvailableProductItem({ product, category, onClick, }: AvailableProductItemProps) {

    const isActive = product.isActive
    const [loading, setLoading] = useState<Boolean>(true);
    const imgSrc = product.image ? `${IMAGE_BASE_URL}/${product.image}` : noImgCoffee

    return (
        <div 
            onClick={() => {
                if (!isActive) return; 
                onClick(product)
            }} 
            className={`${!isActive ? 'bg-gray-300 border-gray-300 cursor-not-allowed' : 'bg-white border-cbColorSecond cursor-pointer hover:shadow-md transition'} relative flex flex-col border rounded-lg border-t-4`}
        >
            <div className="relative w-full h-20 md:h-24 lg:h-40 p-1">
                {loading && (
                    <div className="absolute inset-0 flex items-center justify-center animate-pulse bg-gray-100 rounded-t-md">
                        Loading...
                    </div>
                )}
                <img
                    src={imgSrc}
                    alt={product.productName}
                    onLoad={() => setLoading(false)}
                    onError={(e) => {
                        setLoading(false);
                        e.currentTarget.src = noImgCoffee;
                    }}
                    className={`${
                        loading ? "opacity-0" : !isActive ? "opacity-40" : "opacity-100"
                    } w-full h-full object-cover rounded-t-md transition-opacity`}
                />
                {!isActive && (
                    <>
                        <div className="absolute inset-1 bg-black/35 rounded-t-md" />
                        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                            <span className="rotate-[-20deg] text-white text-[7px] md:text-[10px] lg:text-[12px] font-extrabold tracking-[0.35em] uppercase opacity-90 select-none">
                                UNAVAILABLE
                            </span>
                        </div>
                    </>
                )}
            </div>
            <div className="px-2.5 pb-2.5 flex flex-col">
                <p className="text-xs truncate">
                    {`${category.split(" ")[0]} | ${product.productName}`}
                </p>
                <p className="text-xs">{product.size}</p>
            </div>
            {isActive && (
                <div className="absolute right-4 top-3 bg-gray-100 rounded-full p-1">
                    <GridiconsAdd width={25} height={25} />
                </div>
            )}
        </div>
    )
}
